// extracted by mini-css-extract-plugin
export default {"wrapper":"O_CapsuleCreateHeaderMobile_wrapper__BzWWu","center_wrapper":"O_CapsuleCreateHeaderMobile_center_wrapper__ZP9Fg"};